module.exports = __webpack_public_path__ + "img/bluetooth_pen.1eb8be8a.png";